import { useEffect } from "react";

export default function useOutsideClickHider(ref, hideSetter) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (Array.isArray(ref)) {
        if (
          !(
            ref[0]?.current?.contains(event.target) ||
            ref[1]?.current?.contains(event.target)
          )
        ) {
          hideSetter(true);
        }
      } else if (ref.current && !ref.current?.contains(event.target)) {
        hideSetter(true);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, hideSetter]);
}
